import React from "react";
import { Link } from "gatsby";
import { truncate } from "modules/utils";

import CategoryName from "./CategoryName";
import DividerSVG from "modules/theme/artwork/resource-hub-post.svg";
import LazyloadImage from "modules/lazyload/Image";
import AxelosSVG from "modules/theme/logos/axelos-icon.svg";

import * as styles from "./styles.module.scss";
import { useDataLayer } from "modules/gtm";

export type ResourceHubPostProps = {
  contentType: string;
  image?: string | null;
  id?: string;
  publicationDate?: string;
  timeToRead?: number;
  title: string;
  url: string;
};

type ResourceHubPostImageProps = {
  image: string;
};

type ResourceHubPlaceholderImageProps = {};

export const PostImage: React.FunctionComponent<ResourceHubPostImageProps> = ({ image }) => {
  return (
    <LazyloadImage
      desktop={{ height: 400, width: 800, aspectRatio: "2:1" }}
      mobile={{ height: 355, width: 328, aspectRatio: "328:355" }}
      src={image}
      tagName="div"
    />
  );
};

export const PlaceholderImage: React.FunctionComponent<ResourceHubPlaceholderImageProps> = () => {
  return (
    <span className={styles.placeholder}>
      <AxelosSVG />
    </span>
  );
};

const Post: React.FC<ResourceHubPostProps> = ({ contentType, image, publicationDate, timeToRead, title, url }) => {
  const date_format = publicationDate && new Date(publicationDate);
  const published =
    date_format &&
    date_format.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  const postLink = {
    title: contentType,
    url: url,
  };

  return (
    <Link
      aria-label={title}
      className={styles.resourceHubPost}
      onClick={() => {
        useDataLayer({ action: "Content Click", category: "Resource Hub", label: postLink?.url });
      }}
      onMouseDown={(e: any) => e.preventDefault()}
      to={postLink?.url}
    >
      {image !== null && image !== undefined ? <PostImage image={image} /> : <PlaceholderImage />}
      <div>
        {(published || timeToRead) && (
          <p>
            {published} {timeToRead && ` | ${timeToRead} min read`}
          </p>
        )}
        <h3>{truncate(title, 120)}</h3>
        {postLink?.title && <CategoryName title={postLink?.title} />}
        <DividerSVG />
      </div>
    </Link>
  );
};

export default Post;
